"use client"
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { MdLastPage, MdFirstPage, MdNavigateNext } from "react-icons/md";
import { GrFormPrevious } from "react-icons/gr";
import {observer} from "mobx-react";

const Pagination = observer(({
                                 totalItems = 0,
                                 itemCountPerPage,
                                 pageCount,
                                 currentPage,
                                 setPageIndex,
                                 setPage = () => {},
                             })=>{
    const totalPages = Math.max(0, Math.ceil(totalItems / itemCountPerPage));
    const safeCurrent = Math.min(Math.max(currentPage ?? 0, 0), Math.max(totalPages - 1, 0));
    const [start, setStart] = useState(1);
    useEffect(() => {
        setStart(Math.floor(safeCurrent / pageCount) * pageCount + 1);
    }, [safeCurrent, pageCount]);

    const end = Math.min(start + pageCount - 1, Math.max(totalPages, 1));

    const setChangePage = (zeroBasePage) => {
        const p = Math.min(Math.max(zeroBasePage, 0), Math.max(totalPages - 1, 0));
        setPageIndex(p);
        setPage?.(p);
    };

    const handlePrev = () => setChangePage(safeCurrent - 1);
    const handleNext = () => setChangePage(safeCurrent + 1);
    return (
        <PaginationContainer className={"flex al-center jc-center"}>
            <PaginationWrap className={"flex al-center"}>
                <button
                    className={`flex al-center jc-center page-direction-btn prev-btn ${start === 0 ? 'no-search' : ''}`}
                    onClick={handlePrev}
                    disabled={safeCurrent <= 0}
                >
                    <GrFormPrevious size={20}/>
                </button>
                <div
                    className={`page-number-btn-wrap flex al-center ${start === 1 ? 'only-chk-left' : ''} ${end === totalPages ? 'only-chk-right' : ''}`}>
                    {Array.from({ length: end - start + 1 }).map((_, idx) => {
                        const pageNumber = start + idx;      // 1-base
                        const zeroBase = pageNumber - 1;     // 0-base
                        return (
                            <div
                                key={pageNumber}
                                onClick={() => setChangePage(zeroBase)}
                                className={`flex al-center jc-center page-numbers pointer ${safeCurrent === zeroBase ? 'active' : ''}`}
                            >
                                <span>{pageNumber}</span>
                            </div>
                        );
                    })}
                </div>
                <button
                    className={`flex al-center jc-center page-direction-btn next-btn`}
                    onClick={handleNext}
                    disabled={safeCurrent >= totalPages - 1}
                >
                    <MdNavigateNext size={20}/>
                </button>
            </PaginationWrap>
        </PaginationContainer>
    );
});

const PaginationContainer = styled.div`
    margin-top: 24px;
`;

const PaginationWrap = styled.div`
    gap: ${({ theme }) => theme.SIZE.PAGINATION.gap};
    .page-direction-btn{
        width: ${({ theme }) => theme.SIZE.PAGINATION.width};
        height: ${({ theme }) => theme.SIZE.PAGINATION.height};
    }
    .page-number-btn-wrap {
        gap: ${({ theme }) => theme.SIZE.PAGINATION.gap};
        .page-numbers {
            letter-spacing: 0.02em;
            width: ${({ theme }) => theme.SIZE.PAGINATION.width};
            height: ${({ theme }) => theme.SIZE.PAGINATION.height};
            font-size: ${({ theme }) => theme.SIZE.PAGINATION.font};
            font-weight: ${({ theme }) => theme.SIZE.PAGINATION.weight};
            color: ${({ theme }) => theme.COLORS.PAGINATION.inActive.font};
            background-color: ${({ theme }) => theme.COLORS.PAGINATION.inActive.bg};
                &.active {
                    color: ${({ theme }) => theme.COLORS.PAGINATION.active.font};
                    font-weight: ${({ theme }) => theme.SIZE.PAGINATION.active.weight};
                    background-color: ${({ theme }) => theme.COLORS.PAGINATION.active.bg};
                    border-radius: 8px;
                }
        }
    }
`;

export default Pagination;
